import React, {useContext} from 'react';
import useBodyScroll from "../../hooks/useBodyScroll";

const HomeContext = React.createContext({
    bodyScrollTop: 0,
});

export const HomeProvider = (props) => {
    const [bodyScrollTop, setBodyScrollTop] = useBodyScroll("home-body");

    const contextValue = React.useMemo(
        () => ({
            bodyScrollTop,
            setBodyScrollTop,
        }),
        [bodyScrollTop, setBodyScrollTop],
    );

    return (
        <HomeContext.Provider value={contextValue}>
            {props.children}
        </HomeContext.Provider>
    );
}

export const useHome = () => {
    return useContext(HomeContext);
}
